<template>
  <div class="login-form-container">
    <div class="enter-stp1 login-enter" v-if="loginStep == 1">
      <img src="assets/img/svg/logo-myMedical.svg" alt="logo" />
      <div class="subtitle">
        אנא הקישו שם משתמש אישי<br class="no_mobile" />
        על מנת להתחבר
      </div>
      <div>
        שם המשתמש זהה לכניסה למערכת הקמיליון
      </div>
      <div class="enter-stp-form">
        <ValidationObserver ref="formLogin">
          <form
            name="userLoginForm"
            v-promise-btn="{ action: 'submit' }"
            @submit.prevent="userLogin"
            autocomplete="off"
          >
            <div class="form_input" :class="{ focused: username }">
              <!-- <label>שם משתמש*</label> -->
              <validation-provider
                name="Username"
                rules="required"
                v-slot="{ errors }"
              >
                <input
                  type="text"
                  name="username"
                  v-model="username"
                  autocomplete="off"
                  placeholder="שם משתמש*"
                />
                <span class="error-message">{{ errors[0] }}</span>
                <div class="error-message" v-if="errorMessage">
                  {{ errorMessage }}
                </div>
              </validation-provider>
            </div>
            <div class="form_submit">
              <button class="bt_blue" type="submit">שלחו לי קוד לנייד</button>
            </div>
          </form>
        </ValidationObserver>
        <div class="external-links">
          <a
            href="https://selfservice.hmc.co.il/m/mSelfService?operation=reset&init=true"
            target="_blank"
            class="link_tx"
            >איפוס סיסמת קמיליון
          </a>
          <a
            href="https://selfservice.hmc.co.il/m/mSelfService?operation=unlock&init=true"
            target="_blank"
            class="link_tx"
            >שחרור משתמש נעול
          </a>
        </div>
      </div>
    </div>
    <div class="enter-stp2 login-enter" v-if="loginStep == 2">
      <img src="assets/img/svg/logo-myMedical.svg" alt="logo" />
      <div class="subtitle">
        הודעת <span class="tx--en">SMS</span> עם קוד ההתחברות נשלחה <br />
        למספר <span class="ltr">{{ phone_number }}</span>
      </div>
      <validation-observer ref="smsForm">
        <form
          v-promise-btn="{ action: 'submit' }"
          @submit.prevent="validateSMS"
        >
          <label class="label-otp">יש להזין את המספר שהתקבל*</label>
          <validation-provider
            rules="required|length:6"
            name="sms_code"
            mode="lazy"
            v-slot="{ errors }"
            class="form_input input-48 flex flex--content--center flex--reverse otp-input-form"
          >
            <v-otp-input
              name="sms_code"
              v-model="code"
              input-classes="otp-input"
              separator=" "
              :num-inputs="6"
              :should-auto-focus="true"
              :is-input-num="true"
              @on-complete="handleOnComplete"
              @on-change="handleOnChange"
            />
            <span class="error-message">{{ errors[0] }}</span>
          </validation-provider>

          <div class="form_submit">
            <button class="bt_blue" type="submit">אישור</button>
          </div>
        </form>
      </validation-observer>
      <div class="error-message" v-if="errorMessage">{{ errorMessage }}</div>
      <div class="error-message" v-if="smsSent">נישלחה הודעה נוספת</div>

      <a class="link_tx" href="javascript:void(0);" @click="returnStep()">
        לא קיבלת? חזור לשלב הקודם
      </a>
    </div>
    <div class="enter-stp3 login-enter" v-if="loginStep == 3">
      <img src="assets/img/svg/logo-myMedical.svg" alt="logo" />
      <div class="title title--55 ft--400">ברוכים הבאים</div>
      <div class="subtitle">מהו היומן המבוקש</div>
      <div class="enter-stp-form">
        <form @submit.prevent="selectDoctor">
          <div class="filter_select">
            <select2 v-model="doctor"
              ><option value="">בחרו יומן רופא</option>
              <option
                :value="doctor.id"
                v-for="doctor in doctors"
                :key="doctor.id"
              >
                {{ doctor.name }}
              </option>
            </select2>
          </div>

          <div class="form_submit" :class="{ bt_disable: doctor === '' }">
            <input type="submit" value="כניסה" />
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import Error from "@/components/Popups/Error";

export default {
  data() {
    return {
      username: "",
      password: "",
      user_id: this.$store.getters.activeUser.user_id || "",
      loginStep: 1,
      phone_number: "",
      code: "",
      errorMessage: "",
      doctor: "",
      loginStepErr: false,
      smsSent: false,
      isMobile: false,
      isLoading: false,
      otpAttempts: 0,
      maxOtpAttempts: 5
    };
  },
  computed: {
    ...mapGetters(["doctors", "activeUser"])
  },
  watch: {
    loginStep(value) {
      this.$emit("changeStep", { step: value });
    },
    username(val) {
      if (!val) this.errorMessage = null;
    }
  },
  methods: {
    ...mapActions(["SET_USER", "SET_DOCTOR", "SET_USER_DOCTORS", "LOGOUT"]),
    ...mapMutations(["SET_DOCTOR_ROOMS"]),
    async userLogin() {
      this.loginStepErr = false;
      this.errorMessage = "";
      const valid = await this.$refs.formLogin.validate();
      if (!valid) return;
      try {
        const res = await this.$API.login(this.username, this.password);
        this.user_id = res.message.user_id;
        this.phone_number = res.message.phone;
        this.loginStep = 2;
        var user = {
          user_id: this.user_id,
          name: "",
          phone_number: this.phone_number,
          doctors: []
        };
        this.$store.dispatch("SET_USER", user);
      } catch (e) {
        this.$modal.show(Error, { title: "התרחשה שגיאה אנא פנה לתמיכה" });
      }
    },
    returnStep() {
      this.username = "";
      this.loginStep = 1;
      this.otpAttempts = 0;
      this.errorMessage = "";
    },
    resetToStep1() {
      this.username = "";
      this.code = "";
      this.loginStep = 1;
      this.otpAttempts = 0;
      this.errorMessage = "";
      this.phone_number = "";
      this.user_id = "";
    },
    sendSMS() {
      this.$API.sendSMS(this.user_id);
      this.smsSent = true;
    },
    handleOnComplete(value) {
      this.code = value;
      this.validateSMS();
    },
    handleOnChange(val) {
      if (val.length === 6) this.handleOnComplete(val);
    },
    async validateSMS() {
      if (this.isLoading) return;

      this.isLoading = true;
      this.errorMessage = "";
      await this.$refs.smsForm.validate();
      return new Promise((resolve, reject) => {
        this.$refs.smsForm
          .validate()
          .then(res => {
            if (res) {
              this.$API
                .validateSMS(this.code, this.user_id)
                .then(res => {
                  if (res.status == "OK") {
                    // Reset attempts on successful validation
                    this.otpAttempts = 0;

                    // Set secure cookie with proper configuration
                    this.$cookies.set("hmc_token", res.login_token, {
                      expires: "1D",
                      path: "/",
                      secure: process.env.NODE_ENV === "production",
                      sameSite: "Strict"
                      // Note: HttpOnly should be set by server for maximum security
                      // Client-side cookies cannot be HttpOnly as we need to access them
                    });

                    this.$API
                      .getConnectedCalendars(this.user_id)
                      .then(res => {
                        if (res.status == "OK") {
                          if (!res.message.length) {
                            this.$modal.show(Error);
                            this.LOGOUT().then(() => {
                              this.$API
                                .logout()
                                .then(() => this.$router.push("/"));
                            });
                          } else {
                            this.SET_USER_DOCTORS(res.message);
                            this.$API.getUserInfo().then(res => {
                              this.$store.dispatch("SET_USER", res.message);
                            });
                            if (res.message.length == 1) {
                              this.doctor = res.message[0].id;
                              this.selectDoctor();
                            } else {
                              this.loginStep = 3;
                            }
                          }
                        } else {
                          this.$API
                            .logout()
                            .then(res => {
                              this.$router.push("/");
                            })
                            .catch(e => {});
                          localStorage.setItem("activeDoctor", null);
                          this.SET_USER({});
                          this.SET_USER_DOCTORS(null);
                        }
                      })
                      .catch(e => {
                        this.$modal.show(Error);
                      });
                  }
                })
                .catch(e => {
                  // Increment attempt counter on failed validation
                  this.otpAttempts++;

                  // Check if max attempts reached
                  if (this.otpAttempts >= this.maxOtpAttempts) {
                    this.errorMessage =
                      "חרגת ממספר הנסיונות המותר. אנא התחל מחדש.";
                    setTimeout(() => {
                      this.resetToStep1();
                    }, 2000);
                  } else {
                    const remainingAttempts =
                      this.maxOtpAttempts - this.otpAttempts;
                    this.errorMessage = `${e.message} (נותרו ${remainingAttempts} נסיונות)`;
                  }
                  reject();
                })
                .finally(() => {
                  this.isLoading = false;
                });
            } else {
              resolve();
            }
          })
          .catch(e => {
            reject();
          });
      });
    },
    async selectDoctor() {
      this.SET_DOCTOR(this.doctor);
      this.$API.getRoomsByDoctor(this.doctor).then(res => {
        this.SET_DOCTOR_ROOMS(res.data.data);
      });

      // For new version, reload window
      setTimeout(() => {
        window.location.reload();
      }, 1000);

      // Go to last route if exists
      const initialRoute = sessionStorage.getItem("initial-route");
      if (initialRoute) {
        this.$router.push(initialRoute).catch(() => {});
        return;
      }

      // For mobile/desktop first entrance is different
      const isMobile = window.innerWidth < 1200;
      if (isMobile) {
        this.$router.push({ name: "lobby" });
      } else {
        this.$router.push({ name: "Dashboard" });
      }
    }
  },
  mounted() {
    this.isMobile = window.innerWidth < 1200;
  }
};
</script>

<style>
.vue-pincode-input-wrapper input {
  -webkit-appearance: none;
  -webkit-tap-highlight-color: transparent;
  -moz-outline-style: none;
  outline: none;
  width: 100%;
  height: 80px;
  background: rgba(44, 44, 44, 0.08);
  border: none;
  padding: 0;

  border-bottom: 3px solid transparent;
}
.otp-input-form {
  direction: ltr !important;
}
.enter-stp1 .subtitle {
  margin-bottom: 20px;
}
.external-links {
  margin-top: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.3rem;
}
.external-links a {
  font-size: 0.85rem;
  text-underline-offset: 10px;
}
.external-links.terms a {
  color: white;
  font-size: 0.85rem;
  text-decoration: underline;
  text-underline-offset: 10px;
}
.external-links.terms {
  margin-top: 1.2rem;
}

@media screen and (max-width: 1200px) {
  .external-links a,
  .external-links.terms a {
    font-size: 0.66rem;
  }

  .external-links.terms {
    margin-top: 0.5rem;
  }
}
</style>
